<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <RepseFilter
      name="repse-filter"
      :statusList="statusList"
      v-model="params"
      @search="search"
    />

    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <repse-vendor-table
            :data="data"
            @loadMore="loadMore"
            @search="search"
            @details="details"
            @openFilter="openFilter"
            @updateStatus="changeActive"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>
  
<script>
import RepseFilter from './components/RepseFilter.vue'
import RepseVendorTable from './components/RepseVendorTable.vue'
import repse from '../requests/repse.js'
import loading from '@/mixins/Loading'

export default {
  components: {
    RepseFilter,
    RepseVendorTable,
  },
  data() {
    return {
      data: [],
      filters: {
        status: '',
      },
      lastPage: 1,
      loadingPage: 'repse-loading',
      params: {
        search: '',
        page: 1,
        sortBy: ['Vendors.VendorName'],
        sort: ['ASC'],
        active:false
      },
      statusList: [],
    }
  },
  methods: {
    getData: function () {
      this.openLoading(this.loadingPage)
      repse
        .list(this.params)
        .then((response) => {
          let data = response.data.data
          data.map((obj) => {
            obj.repse_active = obj.repse_active === '1' ? 1 : 0
            return obj
          })
          if (this.params.page === 1) {
            this.data = [...data]
          } else {
            this.data = [...this.data, ...response.data.data]
          }
          this.lastPage = response.data.last_page
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
    loadMore: function () {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    openFilter: function () {
      this.$store.dispatch('toggleSidebar', 'repse-filter')
    },
    search: function (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    details: function (id) {
      this.$router.push({ name: 'repse-documentation', params: { id } })
    },
    changeActive: function (item) {
      this.openLoading(this.loadingPage)
      repse
        .changeActive(item)
        .then((response) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Vendor Updated',
          })
          this.getData()
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
    getStatusList: function () {
      this.openLoading(this.loadingPage)
      repse
        .getStatusList(this.params)
        .then((response) => {
          this.statusList = [... response.data.statusList]
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          this.closeLoading(this.loadingPage)
        })
    },
  },
  mixins: [loading],
  mounted: function () {
    this.getData()
    this.getStatusList()
  },
}
</script>
  
  <style>
</style>